/**
* prism.js Twilight theme
* Based (more or less) on the Twilight theme originally of Textmate fame.
* @author Remy Bach
*/
.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #fff;
	--pce-bg: #141414;
	--pce-widget-border: #383838;
	--pce-widget-bg: #141414;
	--pce-widget-color: #ccc;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #aaa;
	--pce-widget-bg-input: #222;
	--pce-widget-bg-hover: #282828;
	--pce-widget-bg-active: #336699;
	--pce-widget-focus: #5299e0;
	--pce-search-match: #43474cab;
	--pce-widget-bg-error: #4d1919;
	--pce-widget-error: #cc0000;
	--pce-bg-highlight: #1f1f1f;
	--pce-selection-match: #27292a80;
	--pce-line-number: #8292a2;
	--pce-scrollbar: 0, 0%, 45%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #ededed1f;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #27292a;
	color-scheme: dark;
}

.pce-match {
	--pce-search-match: #3a3e41;
}

.active-line {
	--pce-line-number: #d3d9de;
}

.active-indent {
	--pce-guide-indent: #ededed3d;
}

[class*="language-"] {
	color: #fff;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
	color: #787878;
}

.token.punctuation,
.token.namespace {
	opacity: 0.7;
}

.token.tag,
.token.boolean,
.token.number,
.token.deleted {
	color: #cf694a;
}

.token.keyword,
.token.property,
.token.selector,
.token.constant,
.token.symbol,
.token.builtin {
	color: #f9ee9a;
}

.token.attr-name,
.token.attr-value,
.token.string,
.token.char,
.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string,
.token.variable,
.token.inserted {
	color: #919e6b;
}

.token.atrule {
	color: #7386a5;
}

.token.regex,
.language-regex,
.token.important {
	color: #e9c163;
}

.token.important,
.token.bold {
	font-weight: bold;
}
.token.italic {
	font-style: italic;
}

.token.tag,
.token.attr-name,
.tag > .token.punctuation,
.token.attr-equals {
	color: #ad895c;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
	opacity: 1;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
	opacity: 1;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
	opacity: 1;
}

.token.bracket-error {
	color: #ff1212cc;
	opacity: 1;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #888, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #575757b8;
}
